// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-approval-modal {
  max-width: 768px;
}
.step-approval-modal .ant-modal-content {
  padding: 32px 16px !important;
}
.step-approval-modal .note-container,
.step-approval-modal .note {
  margin-top: var(--spacing-small);
}
.step-approval-modal .note-container .note-checkbox span,
.step-approval-modal .note .note-checkbox span {
  padding: 0;
}
.step-approval-modal .actions {
  margin-top: var(--spacing-regular);
}
.step-approval-modal .actions .btn-term-upload .ant-upload-list {
  margin-top: var(--spacing-extra-small);
}
.step-approval-modal .actions .action-btn-group {
  display: flex;
  gap: var(--spacing-extra-small);
}
.step-approval-modal .actions .action-btn-group .btn-confirm.vert-button[disabled].ant-btn-default span {
  color: var(--color-neutral) !important;
}
.step-approval-modal .actions .action-btn-group .btn-confirm.vert-button:not([disabled]).ant-btn-highlight {
  background-color: var(--color-highlight) !important;
}
.step-approval-modal .actions .action-btn-group .btn-confirm.vert-button:not([disabled]).ant-btn-highlight:hover {
  background-color: var(--color-highlight-darker) !important;
}
.step-approval-modal .actions .action-btn-group .btn-confirm.vert-button:not([disabled]).ant-btn-default {
  border-color: var(--color-highlight) !important;
  color: var(--color-highlight) !important;
}
.step-approval-modal .actions .action-btn-group .btn-confirm.vert-button:not([disabled]).ant-btn-default:hover {
  border-color: var(--color-border) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Concierge/Modals/StepApprovalModal.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAFA;EAII,6BAAA;AACJ;AALA;;EAQI,gCAAA;AACJ;AATA;;EAYQ,UAAA;AACR;AAbA;EAkBI,kCAAA;AAFJ;AAhBA;EAsBQ,sCAAA;AAHR;AAnBA;EA2BM,aAAA;EACA,+BAAA;AALN;AAvBA;EAgCU,sCAAA;AANV;AA1BA;EAqCQ,mDAAA;AARR;AA7BA;EAyCQ,0DAAA;AATR;AAhCA;EA6CQ,+CAAA;EACA,wCAAA;AAVR;AApCA;EAkDQ,4CAAA;AAXR","sourcesContent":[".step-approval-modal {\n  max-width: 768px;\n\n  .ant-modal-content {\n    padding: 32px 16px !important;\n  }\n\n  .note-container, .note {\n    margin-top: var(--spacing-small);\n\n    .note-checkbox {\n      span {\n        padding: 0;\n      }\n    }\n  }\n\n  .actions {\n    margin-top: var(--spacing-regular);\n\n    .btn-term-upload {\n      .ant-upload-list {\n        margin-top: var(--spacing-extra-small);\n      }\n    }\n\n    .action-btn-group {\n      display: flex;\n      gap: var(--spacing-extra-small);\n\n      .btn-confirm.vert-button[disabled].ant-btn-default {\n        span {\n          color: var(--color-neutral) !important;\n        }\n      }\n    \n      .btn-confirm.vert-button:not([disabled]).ant-btn-highlight {\n        background-color: var(--color-highlight) !important;\n      }\n    \n      .btn-confirm.vert-button:not([disabled]).ant-btn-highlight:hover {\n        background-color: var(--color-highlight-darker) !important;\n      }\n    \n      .btn-confirm.vert-button:not([disabled]).ant-btn-default {\n        border-color: var(--color-highlight) !important;\n        color: var(--color-highlight) !important;\n      }\n    \n      .btn-confirm.vert-button:not([disabled]).ant-btn-default:hover {\n        border-color: var(--color-border) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
